module.exports = __webpack_public_path__ + "images/avatars/female/11.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/11.png
// module id = juL4
// module chunks = 154